import MaticIcon from "../assets/icons/networks/matic-icon.png";
import ModeIcon from "../assets/icons/networks/mode_round.png";

export const TOKEN_DECIMALS = 18;

export enum Networks {
    MATIC = 137,
    // MATIC = 80001,
    ZK = 1101,
    MODE = 34443,
}

export const AVAILABLE_CHAINS = [Networks.MATIC, Networks.ZK, Networks.MODE];

export const DEFAULT_NETWORK = Networks.MATIC;

export const NetworksInfo: Record<number, any> = {
    [Networks.MATIC]: {
        chainId: "0x89",
        chainName: "Polygon",
        shortName: "Polygon",
        rpcUrls: ["https://rpc-mainnet.maticvigil.com"],
        blockExplorerUrls: ["https://polygonscan.com/"],
        nativeCurrency: {
            name: "MATIC",
            symbol: "MATIC",
            decimals: 18,
        },
        img: MaticIcon,
    },
    // [Networks.MATIC]: {
    //     chainId: "0x13881",
    //     chainName: "Polygon Mumbai",
    //     shortName: "Polygon",
    //     rpcUrls: ["https://rpc-mumbai.maticvigil.com"],
    //     blockExplorerUrls: ["https://mumbai.polygonscan.com/"],
    //     nativeCurrency: {
    //         name: "MATIC",
    //         symbol: "MATIC",
    //         decimals: 18,
    //     },
    //     img: MaticIcon,
    // },
    [Networks.ZK]: {
        chainId: "0x44D",
        chainName: "Polygon zkEVM",
        shortName: "zkEVM",
        rpcUrls: ["https://zkevm-rpc.com"],
        blockExplorerUrls: ["https://zkevm.polygonscan.com/"],
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18,
        },
        img: MaticIcon,
    },
    [Networks.MODE]: {
        chainId: "0x868B",
        chainName: "Mode",
        shortName: "Mode",
        rpcUrls: ["https://mainnet.mode.network/"],
        blockExplorerUrls: ["https://explorer.mode.network/"],
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18,
        },
        img: ModeIcon,
    },
};
